// src/config/sidebarConfig.ts

import ClientHome from "../../assets/navigations/ClientHome.svg";
import Accounts from "../../assets/navigations/Accounts.svg";
import AnalyticsIcon from "../../assets/navigations/NewAnalyticslogo.svg";
import MeetingsIcon from "../../assets/navigations/new_meetings_logo.svg";
import ActionItemsIcon from "../../assets/navigations/new_Action_Item.svg";
import Ask7GIcon from "../../assets/navigations/Ask7g-icon.svg";
import SettingsIcon from "../../assets/navigations/Settings.svg";
import Vendors from "../../assets/navigations/Vendors.svg";
import Customers from "../../assets/navigations/Customers.svg";
import Prospects from "../../assets/navigations/Prospects.svg";
import MyTaskIcon from "../../assets/sidebar/my-task-icon.svg";
import TeamTaskIcon from "../../assets/sidebar/team-task-icon.svg";
import SubscribeTaskIcon from "../../assets/sidebar/subscribe-task-icon.svg";
import TeamInteractionIcon from "../../assets/sidebar/team-interaction-icon.svg";
import SharedWithMeInteractionIcon from "../../assets/sidebar/shares-with-me-icon.svg";
import SharedByMeInteractionIcon from "../../assets/sidebar/shared-by-me-icon.svg"
import MyInteractionIcon from "../../assets/sidebar/my-interaction-icon.svg";
import AccountlevelTaskIcon from "../../assets/sidebar/account-level-task-icon.svg";
import SubNavTaskIcon from "../../assets/navigations/tasks_sub_nav_icon.svg";
import UserLevelSettingIcon from "../../assets/sidebar/userLevelIcon.svg";
import NotificationSettingIcon from "../../assets/sidebar/notificationSetting.svg";
import SpaceSettingIcon from "../../assets/sidebar/spaceSetting.svg";
import AppConfigurationsIcon from "../../assets/sidebar/appConfigurations.svg";
import CompleteMomTaskIcon from "../../assets/action-items/complete-mom-icon.svg";
import AiRecomendedTaskIcon from "../../assets/sidebar/Ai-recomended-task.svg";
import DomainManagementIcon from "../../assets/sidebar/domain-management.svg";
import BussinessAnalyticsIcon from "../../assets/sidebar/bussiness_analytics_icon.svg";
import VideoGuidesIcon from "../../assets/sidebar/video-guides.svg";
import ReportAnalyticsIcon from "../../assets/sidebar/report-analytics-icon.svg";
import AccountsSpacesIcon from "../../assets/sidebar/accounts_spaces_icon.svg";
import OpportunityIcon from "../../assets/sidebar/sidebar-opportunity-icon.svg";

export interface SidebarItemConfig {
  feature: string;
  text: string;
  icon: string;
  brandIcon: string;
  route: string;
  label: string;
}

export interface SidebarGroupConfig {
  group: "primary" | "secondary";
  items: SidebarItemConfig[];
}

export const SIDEBAR_CONFIG: SidebarGroupConfig[] = [
  {
    group: "primary",
    items: [
      {
        feature: "new_client_overview_page",
        text: "Business Overview",
        icon: ClientHome,
        brandIcon: ClientHome,
        route: "/client",
        label: "Business"
      },
      {
        feature: "accounts_page",
        text: "Accounts",
        icon: Accounts,
        brandIcon: Accounts,
        route: "/accounts/customer",
        label: "Accounts"
      },
      {
        feature: "opportunities_page",
        text: "Opportunities",
        icon: OpportunityIcon,
        brandIcon: OpportunityIcon,
        route: "/opportunities",
        label: "Opportunities",
      },
      {
        feature: "tasks_page",
        text: "Tasks",
        icon: ActionItemsIcon,
        brandIcon: ActionItemsIcon,
        route: "/tasks/my-tasks",
        label: "Tasks"
      },
      {
        feature: "interactions_page",
        text: "Interactions",
        icon: MeetingsIcon,
        brandIcon: MeetingsIcon,
        route: "/meetings/my",
        label: "Interactions"
      },
      {
        feature: "analytics_page",
        text: "Analytics",
        icon: AnalyticsIcon,
        brandIcon: AnalyticsIcon,
        route: "/analytics/interactions",
        label: "Analytics"
      },
      {
        feature: "reporting_page",
        text: "Keyword Search",
        icon: Ask7GIcon,
        brandIcon: Ask7GIcon,
        route: "/reporting",
        label: "Keyword Search"
      },
    ],
  },
  {
    group: "secondary",
    items: [
      {
        feature: "settings_page",
        text: "Settings",
        icon: SettingsIcon,
        brandIcon: SettingsIcon,
        route: "/settings/user-settings",
        label: "Settings"
      },
    ],
  },
];

export const SIDEBAR_SUBNAV_CONFIG = {
  accounts: {
    title: "Accounts",
    feature: "accounts_page",
    items: [
      { label: "Prospects", icon: "Prospects", route: "/accounts/prospect", feature: "prospects" },
      { label: "Customers", icon: "Customers", route: "/accounts/customer", feature: "customers" },
      { label: "Vendors", icon: "Vendors", route: "/accounts/vendor", feature: "vendors" },
      { label: "Spaces", icon: "AccountsSpacesIcon", route: "/accounts/spaces", feature: "spaces" },
    ],
  },  
  
    interactions: {
      title: "Interactions",
      feature: "interactions_page",
      items: [
        {
          label: "My Interactions",
          icon: "MyInteraction",
          route: "/meetings/my",
          feature: "my_interaction",
        },
        {
          label: "Team Interactions",
          icon: "TeamInteraction",
          route: "/meetings/team",
          feature: "team_interactions",
        },
        {
          label: "Shared With Me",
          icon: "SharedWithMe",
          route: "/meetings/shared-with-me",
          feature: "shared_with_me"
        },
        {
          label: "Shared By Me",
          icon: "SharedByMe",
          route: "/meetings/shared-by-me",
          feature: "shared_by_me"
        },
      ],
    },
  
    tasks: {
      title: "Tasks",
      feature: "tasks_page",
      items: [
        {
          label: "Task Overview",
          icon: "AccountlevelTask",
          route: "/tasks/all-tasks",
          feature: "all_tasks"
        },
        {
          label: "My Tasks",
          icon: "MyTask",
          route: "/tasks/my-tasks",
          feature: "my_tasks",
        },
        {
          label: "Team Tasks",
          icon: "TeamTask",
          route: "/tasks/team-tasks",
          feature: "team_tasks",
        },
        {
          label: "Subscribed Tasks",
          icon: "SubscribeTask",
          route: "/tasks/subscribed-tasks",
          feature: "subscribed_tasks",
        },
        {
          label: "AI Recommended Tasks",
          icon: "AiRecomendedTask",
          route: "/tasks/ai-recommended-tasks",
          feature: "ai_recommended_tasks",
        },
        {
          label: "Complete MoM Tasks",
          icon: "CompleteMomTask",
          route: "/tasks/complete-mom-tasks",
          feature: "complete_mom_tasks",
        }
      ],
    },
  
    analytics: {
      title: "Analytics",
      feature: "analytics_page",
      items: [
        {
          label: "Business",
          icon: "BussinessAnalyticsIcon",
          route: "/analytics/business",
          feature: "bussiness_analytics",
        },
        {
          label: "Interactions",
          icon: "MyInteraction",
          route: "/analytics/interactions",
          feature: "interaction_analytics",
        },
        {
          label: "Tasks",
          icon: "SubNavTask",
          route: "/analytics/tasks",
          feature: "task_analytics",
        },
        {
          label: "Pipeline Dashboard",
          icon: "ReportAnalyticsIcon",
          route: "/analytics/report",
          feature: "report_analytics",
        }
      ],
    },
  
    settings: {
      title: "Settings",
      feature: "settings_page",
      items: [
        {
          label: "User Level Settings",
          icon: "UserLevelSetting",
          route: "/settings/user-settings",
          feature: "user_settings"
        },
        {
          label: "Space Settings",
          icon: "SpaceSetting",
          route: "/settings/space-settings",
          feature: "space_settings"
        },
        {
          label: "Notification Settings",
          icon: "NotificationSetting",
          route: "/settings/notification-settings",
          feature: "notification_settings"
        },
        {
          label: "App Configurations",
          icon: "AppConfigurations",
          route: "/settings/app-config",
          feature: "app_settings",
        },
        {
          label: "Domain Management",
          icon: "DomainManagement",
          route: "/settings/org-management",
          feature: "org_management",
        },
        {
          label: "Video Guides",
          icon: "VideoGuides",
          route: "/settings/video-guides",
          feature: "demo_video",
        }
      ],
    },
  };
  

  export const SUBNAV_ICON_MAP: Record<string, string> = {
  Prospects,
  Customers,
  Vendors,
  MyInteraction: MyInteractionIcon,
  TeamInteraction: TeamInteractionIcon,
  SharedWithMe: SharedWithMeInteractionIcon,
  SharedByMe: SharedByMeInteractionIcon,
  AccountlevelTask: AccountlevelTaskIcon,
  MyTask: MyTaskIcon,
  TeamTask: TeamTaskIcon,
  SubscribeTask: SubscribeTaskIcon,
  SubNavTask: SubNavTaskIcon,
  BussinessAnalyticsIcon: BussinessAnalyticsIcon,
  UserLevelSetting: UserLevelSettingIcon,
  SpaceSetting: SpaceSettingIcon,
  NotificationSetting: NotificationSettingIcon,
  AppConfigurations: AppConfigurationsIcon,
  CompleteMomTask: CompleteMomTaskIcon,
  AiRecomendedTask: AiRecomendedTaskIcon,
  DomainManagement: DomainManagementIcon,
  VideoGuides: VideoGuidesIcon,
  ReportAnalyticsIcon: ReportAnalyticsIcon,
  AccountsSpacesIcon: AccountsSpacesIcon,
};

export const resolveActiveRoute = (pathname: string): string => {
  // 1. Handle meeting detail page explicitly
  if (pathname.startsWith("/meeting/")) {
    return "/meetings/my"; // parent Interactions tab
  }
    // sidebar routes
    for (const group of SIDEBAR_CONFIG) {
      for (const item of group.items) {
        if (pathname === item.route || pathname.startsWith(item.route + "/")) {
          return item.route;
        }
      }
    }
  
    // sub-nav routes → map to parent sidebar route
    for (const section of Object.values(SIDEBAR_SUBNAV_CONFIG)) {
      for (const sub of section.items) {
        if (pathname === sub.route || pathname.startsWith(sub.route + "/")) {
          const parent = SIDEBAR_CONFIG
            .flatMap(g => g.items)
            .find(i => i.feature === section.feature);
          if (parent) return parent.route;
        }
      }
    }
  
    return "/client"; // safe fallback
  };
  

  export const resolveDefaultRoute = (
    featureMap: Record<string, boolean>,
    isHighRadiusUser: boolean,
    isImpersonating: boolean = false
  ): string => {
    if (isImpersonating) {
      if (featureMap["accounts_page"] === true && featureMap["customers"] === true) {
        return "/accounts/customer";
      }
      if (isHighRadiusUser && featureMap["interactions_page"] === true) {
        return "/meetings/my";
      }
      sessionStorage.removeItem("impersonationDetails");

      return "/login";
    }

    if (isHighRadiusUser && featureMap["tasks_page"] === true) {
      return "/tasks/all-tasks";
    }
  
    if (featureMap["new_client_overview_page"] === true) {
      return "/client";
    }
  
    return "/meetings/my";
  };  
  
  export const PARENT_ROUTE_TO_SUBNAV: Record<
  string,
  keyof typeof SIDEBAR_SUBNAV_CONFIG
> = {
  "/accounts/customer": "accounts",
  "/meetings/my": "interactions",
  "/tasks/my-tasks": "tasks",
  "/analytics/interactions": "analytics",
  "/settings/user-settings": "settings",
};

export const resolveFirstEnabledSubRoute = (
  parentRoute: string,
  featureMap: Record<string, boolean>,
  isHighRadiusUser: boolean,
): string => {
  const subNavKey = PARENT_ROUTE_TO_SUBNAV[parentRoute];

  if (!subNavKey) {
    return parentRoute; // no sub-nav → go as-is
  }

  const section = SIDEBAR_SUBNAV_CONFIG[subNavKey];

  // Parent feature itself disabled → fallback
  if (featureMap[section.feature] === false) {
    return resolveDefaultRoute(featureMap, isHighRadiusUser);
  }

   // If the default route itself is enabled (e.g. Customers), use it directly
  const defaultItem = section.items.find((item) => item.route === parentRoute);
  if (defaultItem && featureMap[defaultItem.feature] === true) {
    return defaultItem.route;
  }

  // Pick FIRST enabled sub-route in declared order
  for (const item of section.items) {
    if (featureMap[item.feature] === true) {
      return item.route;
    }
  }

  // No sub-route enabled → fallback
  return resolveDefaultRoute(featureMap, isHighRadiusUser);
};
